import React, { useEffect, useState } from 'react';

import { Container, Spinner } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import { MdHome } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getBatch } from './common';
import { getDriverQualificationsCsvData } from './utils';
import Excel from '../../../assets/excel.png';
import { Breadcrumbs, DriverQualificationListTable, SubHeader } from '../../../components';
import { newDateFormatted } from '../../../utils';
import Routes from '../../../utils/routes';

import './styles.scoped.css';

const Request = ({ status }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { type, id } = useSelector(state => state.admin.user);
  const fileName = `driver-qualifications-${status.toLowerCase().replace(/\s+/g, '-')}-${newDateFormatted.toString()}.csv`;

  useEffect(() => {
    if (type && id) {
      getBatch({ type, setData, setLoading, status, userId: id, isFirst: true }).catch(err =>
        console.error('Failed to load driver qualifications:', err),
      );
    }
  }, [type, id]);

  return (
    <Container fluid>
      <SubHeader
        text="Centerline Driver Qualification"
        buttons={[
          {
            icon: <MdHome size={28} color="#FFF" />,
            onPress: () => navigate('../driver-qualification', { replace: true }),
          },
        ]}
        popoverTitle="Need help with your driver qualification?"
      />
      <div className="wrap">
        <Breadcrumbs
          leftTitle="DQF Home"
          rightTitle={`${status} Files`}
          route="/driver-qualification"
          status={status}
          wrapStyle={{ margin: 0 }}
        />
        <CSVLink filename={fileName} data={getDriverQualificationsCsvData(data)}>
          <img src={Excel} alt="export-to-excel" style={{ padding: '20px 30px 0 0 ', cursor: 'pointer' }} />
        </CSVLink>
      </div>

      <Container className="vh-100 mt-5" fluid>
        {loading ? (
          <div className="h-100 d-flex justify-content-center p-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <DriverQualificationListTable
            data={data}
            Route={type === 'Corporate' ? Routes.CorporateDQ : Routes.ClientDQ}
            showFileType={status !== 'Requested'}
          />
        )}
      </Container>
    </Container>
  );
};

export default Request;
